var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagMango(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.416667 20C0.416667 9.18442 9.18442 0.416667 20 0.416667C30.8156 0.416667 39.5833 9.18442 39.5833 20C39.5833 30.8156 30.8156 39.5833 20 39.5833C9.18442 39.5833 0.416667 30.8156 0.416667 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.416667 20C0.416667 9.18442 9.18442 0.416667 20 0.416667C30.8156 0.416667 39.5833 9.18442 39.5833 20C39.5833 30.8156 30.8156 39.5833 20 39.5833C9.18442 39.5833 0.416667 30.8156 0.416667 20Z",
    stroke: "#DDDDE3",
    strokeWidth: 0.833333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6808 11.4221C26.1145 11.2474 26.5575 11.0967 27.0077 10.9709C27.9187 10.7876 28.8644 10.9074 29.7014 11.3122C30.7998 11.8204 31.7981 12.5229 32.6485 13.3862C32.7076 13.4345 32.7564 13.4944 32.7919 13.5621C32.8273 13.6299 32.8488 13.7041 32.8549 13.7804C32.8611 13.8567 32.8518 13.9334 32.8276 14.006C32.8034 14.0786 32.7648 14.1455 32.7142 14.2028C31.7322 15.3625 30.4705 16.2503 29.0493 16.7814C28.201 17.0763 27.2779 17.0726 26.4319 16.7709C26.4 16.762 26.3676 16.7554 26.3349 16.751C26.5435 17.1468 26.7741 17.5185 26.9608 17.909C27.4881 18.966 27.7423 20.1391 27.7002 21.3204C27.6581 22.5018 27.321 23.6536 26.7198 24.6701C25.046 27.8393 22.3658 30.357 19.1042 31.8239C17.3025 32.6251 15.3319 32.9685 13.3665 32.8237C12.4537 32.8004 11.5521 32.6158 10.7031 32.2783C10.0284 32.0095 9.45795 31.5297 9.07615 30.9101C8.69435 30.2905 8.52153 29.5639 8.5833 28.838C8.64235 27.7663 9.09417 26.7542 9.85187 25.9966C10.3643 25.4479 10.7008 24.7575 10.8179 24.0148C11.0464 22.8286 11.2248 21.6298 11.496 20.4551C11.7754 19.1604 12.3302 17.9416 13.1225 16.882C13.9147 15.8224 14.9257 14.9471 16.0862 14.3158C17.0862 13.74 18.2049 13.4028 19.3555 13.3302C20.5062 13.2575 21.6581 13.4515 22.7222 13.8971C22.9047 13.9662 22.9809 13.8971 23.08 13.7819C23.8056 12.9312 24.3219 11.9213 24.5875 10.8337C24.7377 10.2746 24.8243 9.69882 24.9275 9.12719C24.9457 8.96802 25.0237 8.82182 25.1457 8.71848C25.2676 8.61515 25.4243 8.56248 25.5837 8.57126C25.6634 8.57589 25.7412 8.59745 25.8119 8.63451C25.8826 8.67158 25.9447 8.7233 25.994 8.78625C26.0433 8.8492 26.0788 8.92195 26.098 8.99968C26.1171 9.07741 26.1197 9.15834 26.1054 9.23712C26.0083 9.87994 25.8685 10.5175 25.7444 11.1572C25.7319 11.2567 25.6985 11.3509 25.6808 11.4221Z",
    fill: "url(#paint0_linear_11692_191540)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11692_191540",
    x1: 25.4904,
    y1: 19.5925,
    x2: 5.21195,
    y2: 32.9451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321569,
    stopColor: "#ED7E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631373,
    stopColor: "#F5B223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6BB22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagMango);
export default __webpack_public_path__ + "static/media/TagMango.f1997eddffaae1068a2a8ef469b658fd.svg";
export { ForwardRef as ReactComponent };